export default __webpack_public_path__ + "static/media/favicon-32x32_01.3f6d7803.png";